module.exports = __webpack_public_path__ + "img/news-inquiry.58b41cdd.jpg";